import actions from './actions'

const modeLoaded = actions.modeLoaded
const modeLoading = actions.modeLoading
const modePolling = actions.modePolling
const setTabApiMessages = actions.setTabApiMessages
const increasePage = actions.increasePage
const noResultsForTime = actions.noResultsForTime
const noResultsForFerryType = actions.noResultsForFerryType
const noMoreResults = actions.noMoreResults
const setProviderConnectionError = actions.setProviderConnectionError

export default {
  modeLoaded,
  modeLoading,
  setTabApiMessages,
  increasePage,
  noResultsForTime,
  noResultsForFerryType,
  noMoreResults,
  modePolling,
  setProviderConnectionError,
}
